var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLovers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1731",
    "data-name": "Rectangle 1731",
    width: 20.034,
    height: 18.902,
    transform: "translate(0 0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stage_7:_Lovers_Haters",
    "data-name": "Stage 7: Lovers & Haters",
    transform: "translate(-592.108 -302.662)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_686",
    "data-name": "Ellipse 686",
    cx: 14,
    cy: 14,
    r: 14,
    transform: "translate(592.108 302.662)",
    fill: "#ee3d4b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32063",
    "data-name": "Group 32063",
    transform: "translate(596.091 307.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32062",
    "data-name": "Group 32062",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13530",
    "data-name": "Path 13530",
    d: "M13.55,12.345Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13531",
    "data-name": "Path 13531",
    d: "M6.435,12.422A3.122,3.122,0,0,0,9.54,9.537H3.315a3.141,3.141,0,0,0,3.12,2.885",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13532",
    "data-name": "Path 13532",
    d: "M11.4,15.23h5.258a3.123,3.123,0,0,0-3.105-2.885c-.056,0-.109.015-.166.015A6.34,6.34,0,0,1,11.4,15.23",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13533",
    "data-name": "Path 13533",
    d: "M13.741,2.92h-.026v7.392a6.438,6.438,0,0,1-.116,1.2c.061,0,.123-.011.186-.011a4.079,4.079,0,0,1,4.073,4.073.73.73,0,0,1-.728.729H10.445a.722.722,0,0,1-.494-.2,6.272,6.272,0,0,1-1.223.4,6.336,6.336,0,0,0,11.3-3.937l.006-7.392A9.83,9.83,0,0,0,13.741,2.92m2.652,6.934a1.932,1.932,0,0,1-1.93-1.93.48.48,0,0,1,.959,0,.971.971,0,1,0,1.942,0,.48.48,0,0,1,.959,0,1.932,1.932,0,0,1-1.93,1.93",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13534",
    "data-name": "Path 13534",
    d: "M12.682,9.647V2.254A9.833,9.833,0,0,0,6.388,0,10.252,10.252,0,0,0,0,2.254V9.647H0a6.341,6.341,0,0,0,12.682,0M9.045,4.527a1.929,1.929,0,0,1,1.931,1.929.479.479,0,1,1-.958,0,.972.972,0,1,0-1.944,0,.479.479,0,0,1-.478.479h0a.48.48,0,0,1-.48-.479A1.929,1.929,0,0,1,9.045,4.527M2.012,6.456a1.93,1.93,0,0,1,3.86,0,.48.48,0,0,1-.959,0,.971.971,0,0,0-1.942,0,.48.48,0,0,1-.959,0m4.424,6.922A4.071,4.071,0,0,1,2.365,9.307a.731.731,0,0,1,.729-.729H9.781a.729.729,0,0,1,.726.729,4.071,4.071,0,0,1-4.071,4.071",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLovers);
export default __webpack_public_path__ + "static/media/lovers.081f4a3a056f0b26ec05c2892ebb51a6.svg";
export { ForwardRef as ReactComponent };